import { combineReducers } from "redux";
import all_cab_booking from "../features/admin/cab_booking/all_booking/slice";

const cab_bookingmanagement = combineReducers({
  all_cab_booking: all_cab_booking,
});

export default cab_bookingmanagement;
